import React from 'react';

const Grid = ({ className = '' }: { className?: string }): JSX.Element => {
	return (
		<svg
			className={className}
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 20 20">
			<g fill="currentColor">
				<circle cx="2.5" cy="2.5" r="2.5" />
				<circle cx="2.5" cy="2.5" r="2.5" transform="translate(7.5)" />
				<circle cx="2.5" cy="2.5" r="2.5" transform="translate(15)" />
				<circle
					cx="2.5"
					cy="2.5"
					r="2.5"
					transform="translate(0 7.5)"
				/>
				<circle
					cx="2.5"
					cy="2.5"
					r="2.5"
					transform="translate(7.5 7.5)"
				/>
				<circle
					cx="2.5"
					cy="2.5"
					r="2.5"
					transform="translate(15 7.5)"
				/>
				<circle cx="2.5" cy="2.5" r="2.5" transform="translate(0 15)" />
				<circle
					cx="2.5"
					cy="2.5"
					r="2.5"
					transform="translate(7.5 15)"
				/>
				<circle
					cx="2.5"
					cy="2.5"
					r="2.5"
					transform="translate(15 15)"
				/>
			</g>
		</svg>
	);
};

export default Grid;
